import React from 'react';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { TrustSection } from './components/TrustSection';
import { ReliabilityBanner } from './components/ReliabilityBanner';
import { ServicesSection } from './components/ServicesSection';
import { HowItWorks } from './components/HowItWorks';
import { ServiceArea } from './components/ServiceArea';
import { Testimonials } from './components/Testimonials';
import { FAQ } from './components/FAQ';
import { QuoteForm } from './components/QuoteForm';
import { Footer } from './components/Footer';
import { MobileCTABar } from './components/MobileCTABar';
export function App() {
  return <div className="min-h-screen bg-[#FBFCFB] font-body text-gray-900 selection:bg-brand-green/20" data-id="element-0">
      <Header data-id="element-1" />
      <main data-id="element-2">
        <Hero data-id="element-3" />
        <TrustSection data-id="element-4" />
        <ReliabilityBanner data-id="element-5" />
        <ServicesSection data-id="element-6" />
        <HowItWorks data-id="element-7" />
        <ServiceArea data-id="element-8" />
        <Testimonials data-id="element-9" />
        <FAQ data-id="element-10" />
        <QuoteForm data-id="element-11" />
      </main>
      <Footer data-id="element-12" />
      <MobileCTABar data-id="element-13" />
    </div>;
}